import styled from "styled-components";

export const RelativeContainer = styled.div`
	position: relative;
	min-height: 50px;
`;
